<script>
  export let item = {};
  let opened = false;
</script>

<div style="position:relative; z-index: 10000"
     on:mouseenter={() => opened = true}
     on:mouseleave={() => opened = false}>
  <button class="Item {item.active ? 'Active': ''}" data-icon-before="{item.icon}"></button>

  {#if opened}
    {#if item.submenu}
      <div class="ItemExtra">
        <button class="Item Opened MenuHeader {item.active ? 'Active': ''}"  data-icon-before="{item.icon}">{item.label}</button>

        <div class="Menu">
          {#each item.submenu as subItem}
            <button class="MenuItem {subItem.active ? 'Active': ''}" data-icon-before="{subItem.icon}"
                    on:click={()=>subItem.action()}>{subItem.label}</button>
          {/each}
        </div>
      </div>

    {:else}
      <div class="ItemExtra">
        <button class="Item Opened {item.active ? 'Active': ''}"  data-icon-before="{item.icon}"
                on:click={()=>item.action()}>{item.label}</button>
      </div>
    {/if}
  {/if}
</div>

<style lang="stylus">
  @import './styles.blocks.styl'

  .Item {
    {MenuItem}
    background: #313C42;
    border-color: #313C42;

    &:hover {
      opacity: 1;
    }

    &.Opened {
      width: 300px;
      opacity: 1;
      border-radius: 0 5px 5px 0;

      &.MenuHeader {
        text-align: center;
        border-radius: 0 5px 0 0;
      }
    }
  }

  .ItemExtra {
    width: 300px;
    position:absolute;
    top: 0;
    left: 0;
  }

  .Menu {
    width: calc(100% - 48px);
    margin-left: 48px;
    background: #263238;
    border-radius: 0 0 5px 0;
  }

  .MenuItem {
    {MenuItem}
    height: 36px;
    color: #72828A;
    opacity: 0.7;

    &:before {
      margin-right: 10px;
      font-size: 20px;
    }

    &:hover {
      opacity: .9;
    }

    &.Active {
      background: #263238;

      &:before {
        color: #00B8AB;
      }
    }
  }
</style>
